import { defineStore } from "pinia";
import { ref } from "vue";
export const useAdminStore = defineStore("admin", () => {
    const project = ref(null);
    const customer = ref(null);
    const reseller = ref(null);
    function setProject(proj) {
        project.value = proj;
        localStorage.setItem("selectedAdminProject", JSON.stringify(proj));
    }
    function setCustomer(cust) {
        customer.value = cust;
        localStorage.setItem("selectedAdminCustomer", JSON.stringify(cust));
    }
    function setReseller(res) {
        reseller.value = res;
        localStorage.setItem("selectedAdminReseller", JSON.stringify(res));
    }
    return {
        project,
        customer,
        reseller,
        setProject,
        setCustomer,
        setReseller
    };
});
